import $ from "jquery";
import anime from "animejs";
import ScrollMagic from "scrollmagic";
import { guid } from "./helper";

// init Scrollmagic controller

// var controller = new ScrollMagic.Controller({ addIndicators: true });
var controller = new ScrollMagic.Controller();

/**
 * Anime - Fade in
 */
$('[data-anime-type="fade-in"]').each(function () {
    // console.log($(this));

    var uuid = guid();
    $(this).attr("data-anime-id", uuid);

    new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '[data-anime-id="' + uuid + '"]',
        triggerHook: "onEnter",
        reverse: false,
    })
        .addTo(controller)
        .on("enter", function (e) {
            $('[data-anime-id="' + uuid + '"]').addClass("s_is-in-viewport");

            anime({
                targets: ['[data-anime-id="' + uuid + '"] [data-anime-elem]'],
                opacity: [0, 1],
                duration: 1000,
                easing: "easeInOutQuart",
                delay: function (el, index) {
                    return 100 + index * 120;
                },
            });
        });
});

/**
 * Anime - Transform in
 */

$('[data-anime-type="transform-in"]').each(function () {
    var uuid = guid();
    $(this).attr("data-anime-id", uuid);

    // set scene
    new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '[data-anime-id="' + uuid + '"]',
        triggerHook: "onEnter",
        reverse: false,
    })
        .addTo(controller)
        .on("enter", function (e) {
            $('[data-anime-id="' + uuid + '"]').addClass("s_is-in-viewport");

            anime({
                targets: ['[data-anime-id="' + uuid + '"] [data-anime-elem]'],
                translateY: ["20px", "0px"],
                opacity: [0, 1],
                duration: 1000,
                easing: "easeOutQuart",
                delay: function (el, index) {
                    return 100 + index * 80;
                },
                complete: function () {
                    $('[data-anime-id="' + uuid + '"] [data-anime-elem]').css(
                        "transform",
                        ""
                    );
                },
            });

            anime({
                targets: [
                    '[data-anime-id="' + uuid + '"] [data-anime-scale-elem]',
                ],
                scale: [2, 1],
                opacity: [0, 1],
                duration: 1000,
                easing: "easeOutQuart",
                delay: function (el, index) {
                    return 100 + index * 80;
                },
                complete: function () {
                    $(
                        '[data-anime-id="' + uuid + '"] [data-anime-scale-elem]'
                    ).css("transform", "");
                },
            });

            $('[data-anime-id="' + uuid + '"] [data-anime-count]').each(
                function () {
                    var uuid = guid();
                    $(this).attr("data-anime-count-id", uuid);

                    var amount = {
                        number: 0,
                    };
                    var total = parseInt(
                        $(this).attr("data-anime-count-value")
                    );

                    anime({
                        targets: amount,
                        number: total,
                        duration: 2000,
                        delay: 600,
                        round: 1,
                        easing: "easeOutExpo",
                        update: function () {
                            $(
                                '[data-anime-count-id="' +
                                    uuid +
                                    '"] [data-anime-count-elem]'
                            ).text(amount["number"]);
                        },
                    });
                }
            );
        });
    // .on("progress", function(e) {
    //   // console.log(e.progress);
    // });
});

/**
 * Anime - Header case
 */

$('[data-anime-type="header-case"]').each(function () {
    var uuid = guid();
    $(this).attr("data-anime-id", uuid);

    // set scene
    new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '[data-anime-id="' + uuid + '"]',
        triggerHook: "onEnter",
        reverse: false,
    })
        .addTo(controller)
        .on("enter", function (e) {
            $('[data-anime-id="' + uuid + '"]').addClass("s_is-in-viewport");

            anime({
                targets: "#header-case-content",
                opacity: [0, 1],
                duration: 1000,
                easing: "easeOutQuart",
                delay: 1200,
            });

            anime({
                targets: "#header-case-hook",
                translateX: ["-50%", "-50%"],
                keyframes: [
                    {
                        translateY: ["-700px", "-300px"],
                        opacity: [0, 1],
                        duration: 500,
                        delay: 100,
                        easing: "easeOutExpo",
                    },
                    {
                        translateY: ["-300px", "100px"],
                        duration: 500,
                        delay: 100,
                        easing: "easeOutExpo",
                    },
                    {
                        translateY: ["100px", "0px"],
                        duration: 400,
                        delay: 50,
                        easing: "easeOutBack",
                    },
                    {
                        translateY: ["0px", "-300px"],
                        opacity: [1, 0],
                        duration: 700,
                        delay: 50,
                        easing: "easeOutBack",
                    },
                ],
            });
            anime({
                targets: "#header-case-visual",
                keyframes: [
                    {
                        translateY: ["100px", "100px"],
                        opacity: [0, 1],
                        duration: 600,
                        easing: "easeOutBack",
                        delay: 300,
                    },
                    {
                        translateY: ["100px", "0px"],
                        duration: 400,
                        easing: "easeOutBack",
                        delay: 350,
                    },
                ],
                complete: function () {
                    $('[data-anime-id="' + uuid + '"] [data-anime-elem]').css(
                        "transform",
                        ""
                    );
                },
            });
        });
    // .on("progress", function(e) {
    //   // console.log(e.progress);
    // });
});

/**
 * Anime - none
 */
$('[data-anime-type="none"] [data-anime-elem]').css("opacity", "1");
